import React, { ButtonHTMLAttributes, ReactElement } from 'react';
import { Grid, Tile } from './styles';

type TActionTileProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  /** Ícone Myicons; a cor vem de currentColor. */
  icon: ReactElement;
  label: string;
};

/**
 * Ação de gestão do torneio. No celular vira bloco com ícone em cima (alvo de
 * toque grande); a partir de 48rem vira botão de linha, como os atuais.
 */
export const ActionTile: React.FC<TActionTileProps> = ({
  icon,
  label,
  ...rest
}) => (
  <Tile type="button" {...rest}>
    {React.cloneElement(icon, {
      'aria-hidden': true,
      stroke: 'currentColor',
      fill: 'none',
      strokeWidth: icon.props.strokeWidth ?? 1.75,
    })}
    <span>{label}</span>
  </Tile>
);

interface IActionGridProps {
  children: React.ReactNode;
  'aria-label'?: string;
}

const ActionGrid: React.FC<IActionGridProps> = ({
  children,
  'aria-label': ariaLabel = 'Gerenciar torneio',
}) => (
  <Grid role="group" aria-label={ariaLabel}>
    {children}
  </Grid>
);

export default ActionGrid;
